// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import constants from "@store/constants";
import { useTrailerTrackingV2DataView } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import TrailerTrackingV2CardList from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2CardList";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import usePreviousExisting from "@toolkit/Framework/Common/Hooks/usePreviousExisting";
import React, { FC } from "react";
import TrailerTrackingV2FilterTags from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterTags";

const enum fields {
    showRequestPickupButton = "showRequestPickupButton",
}

export interface TrailerTrackingListProps extends WidgetProps {
    fields: {
        [fields.showRequestPickupButton]: boolean;
    };
}

export interface TrailerTrackingListStyles {
    wrapper?: InjectableCss;
    apiErrorInfosBox?: InfosBoxProps;
    noResultsText?: TypographyPresentationProps;
}

export const trailerTrackingListStyles: TrailerTrackingListStyles = {
    apiErrorInfosBox: { type: "error" },
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
};

const styles = trailerTrackingListStyles;

const TrailerTrackingList: FC<TrailerTrackingListProps> = ({ fields }) => {
    const dataView = useTrailerTrackingV2DataView();
    const { value: results } = usePersistentDataView(dataView);
    const previousLoadingFailed = usePreviousExisting(dataView.loadingFailed);
    const loadingFailed = dataView.loadingFailed || previousLoadingFailed;

    return (
        <StyledWrapper {...styles.wrapper}>
            <DataViewLoadingOverlay dataView={dataView}>
                {loadingFailed ? (
                    <InfosBox {...styles.apiErrorInfosBox}>{translate("An error occurred. Try again later.")}</InfosBox>
                ) : (
                    <>
                        <TrailerTrackingV2FilterTags />
                        {!results?.length ? (
                            <Typography
                                {...styles.noResultsText}
                                data-test-selector="trailerTrackingTable_noTrailersFound"
                            >
                                {translate("No trailers found")}
                            </Typography>
                        ) : (
                            <TrailerTrackingV2CardList
                                cards={results}
                                showRequestPickupButton={fields.showRequestPickupButton}
                                filteredTrailerCount={dataView.filteredTrailerCount}
                                totalTrailerCount={dataView.totalTrailerCount}
                            />
                        )}
                    </>
                )}
            </DataViewLoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: TrailerTrackingList,
    definition: {
        displayName: "List (V2)",
        group: constants.widgetGroup.trailerTracking,
        allowedContexts: [constants.pageType.trailerTracking],
        fieldDefinitions: [
            {
                name: fields.showRequestPickupButton,
                displayName: "Show Request Pickup Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
